import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { ClipLoader } from "react-spinners";

type LoaderProps = {
  isLoading?: boolean;
  size?: number;
};

export function Loader({ isLoading = true, size }: LoaderProps) {
  const theme = useTheme();

  return (
    <ClipLoader
      size={size}
      loading={isLoading}
      color={theme.palette.primary.main}
    />
  );
}

type BoxLoaderProps = LoaderProps & {
  height?: string | number;
};

export function BoxLoader({ isLoading = true, height }: BoxLoaderProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height,
      }}
    >
      <Loader />
    </Box>
  );
}

type CircularProgressLoaderProps = LoaderProps & {
  progress: number;
};

export function CircularProgressLoader({
  isLoading = true,
  progress,
}: CircularProgressLoaderProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" value={progress} />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="text.primary"
          >{`${Math.round(progress)}%`}</Typography>
        </Box>
      </Box>
      <Box sx={{ mt: 2 }}>Processing files...</Box>
    </Box>
  );
}
